// extracted by mini-css-extract-plugin
module.exports = {"compose":"ComposeMail_compose__1Wlo1","header":"ComposeMail_header__3lDIm","inpGroup":"ComposeMail_inpGroup__1qvda","send":"ComposeMail_send__27piS"};